import SnackbarUtils from "@/../bower_components/teknisavuecomponents/assets/utils/SnackbarUtils";
import OfflineController from '@/assets/ts/controller/OfflineController';
import DynamicRepository from "./DynamicRepository";
import { OfflineTables } from '@/assets/ts/offline/DynamicTables';


// Classe responsável por criar as tabelas necessárias para o funcionamento offline no SQLite.
class CreateRepository {
  public static async create(): Promise<any> {
    try {
      await this.createRegistroTables();
      await DynamicRepository.createTables(OfflineTables);
    } catch (err) {
      console.log(`Ocorreu um erro ao criar as tabelas para o offline: ${err}`);
    }
  }

  private static async createRegistroTables(): Promise<void> {
    try {
      const db = OfflineController.getDB();

      await new Promise((resolve, reject) => {
        db.transaction(
          (tx) => {
            tx.executeSql(
              'CREATE TABLE IF NOT EXISTS USER (NRUSER TEXT PRIMARY KEY, NRVINCULOM TEXT, NMOPERADOR TEXT, NRORG TEXT, NRPARCNEGOCIO TEXT, CDOPERADOR TEXT, ISDP TEXT, IDEXIGEFOTOREGPNTPG TEXT, IDPGRESTRINGETELAREGIST TEXT)'
            );
            tx.executeSql(
              'CREATE TABLE IF NOT EXISTS ESTRUTURAM (NRESTRUTURAMOFF TEXT PRIMARY KEY, NRESTRUTURAM TEXT, NMESTRUTURA TEXT, IDTIPOESTRUTURA TEXT)'
            );
            tx.executeSql(
              'CREATE TABLE IF NOT EXISTS PTO_PERIODOAPURACAO (NRPERIODOAPURACAOOFF TEXT PRIMARY KEY, NRPERIODOAPURACAO TEXT, DSPERIODOAPURACAO TEXT, IDPERIODOAPURACAO TEXT, DTINICIALAPURACAO TEXT, DTFINALAPURACAO TEXT)'
            );
            tx.executeSql(
              'CREATE TABLE IF NOT EXISTS GPE_VINCULOM (NRVINCULOMOFF TEXT PRIMARY KEY, NRVINCULOM TEXT, NMVINCULOM TEXT, NRORG TEXT, CDOPERADOR TEXT, NRCPFPESSOA TEXT)'
            );
            tx.executeSql(
              'CREATE TABLE IF NOT EXISTS GPE_MARCACAOPONTO (NRMARCACAOOFFLINE TEXT PRIMARY KEY, NRCHAVEVINCULO TEXT, NMVINCULOM TEXT, DTHRMARCACAOPONTO TEXT, IDALMOCO TEXT, IDSINCRONIZADO TEXT, DSLATITUDE TEXT, DSLONGITUDE TEXT, DSPATH TEXT, DSERROMARCACAO TEXT)'
            );
          },
          (error) => {
            reject(error);
          },
          () => {
            resolve('');
          }
        );
      });
    } catch (err) {
      SnackbarUtils.showMessage('SQLite - Ocoreu um erro ao criar as tabelas necessarias para o modo offline', SnackbarUtils.TYPE_ERROR);
      throw err;
    }
  }
  
}

export default CreateRepository;
